import { ThemeOptions } from '../material';

// https://www.figma.com/file/AaBwZVqcfaoe476bCiLqmJ/Rossum-Design-System-%E2%80%94-Dark?node-id=6785%3A42814
export const darkThemeOptions: ThemeOptions = {
  palette: {
    mode: 'dark',
    primary: {
      main: '#1E6EE5',
      light: '#61A0FF',
      dark: '#0B5BD2',
    },
    secondary: {
      main: '#8D99B0',
      light: '#CAD1DA',
      dark: '#8895AC',
    },
    success: {
      main: '#10B40D',
      light: '#12D60F',
      dark: '#0E980B',
    },
    info: {
      main: '#0BACD0',
      light: '#12C9F3',
      dark: '#087C96',
    },
    warning: {
      main: '#FF7A0D',
      light: '#FF8F33',
      dark: '#DB6300',
    },
    error: {
      main: '#F33321',
      light: '#FB5646',
      dark: '#C61B0B',
    },
    aurora: {
      main: '#8811E3',
      light: '#EF9CFD',
      dark: '#720EBE',
      contrastText: '#FFFFFF',
    },
    text: {
      primary: 'rgba(255, 255, 255, 1)',
      secondary: 'rgba(141, 153, 176, 1)',
      disabled: 'rgba(82, 97, 117, 1)',
    },
    action: {
      active: '#A6B1C1',
      hover: 'rgba(159, 196, 249, 0.08)',
      selected: 'rgba(159, 196, 249, 0.14)',
      disabled: 'rgba(75, 89, 108, 0.8)',
      disabledBackground: 'rgba(75, 89, 108, 0.4)',
      focus: 'rgba(166, 177, 193, 0.5)',
    },
    other: {
      tooltip: '#435061',
      defaultPrimary: '#1E6EE5',
      outlinedBorder: 'rgba(166, 177, 193, 0.24)',
      backdropOverlay: 'rgba(13, 17, 23, 0.6)',
      filledInputBackground: 'rgba(166, 177, 193, 0.08)',
      standardInputLine: 'rgba(166, 177, 193, 0.42)',
    },
    elevation: {
      0: {
        background: 'none',
        shadow: '0px 0px 0px 1px rgba(166, 177, 193, 0.06) inset',
      },
      2: {
        background: 'rgba(26, 31, 39, 1)',
        shadow: '0px 0px 0px 1px rgba(166, 177, 193, 0.06) inset',
      },
      4: {
        background: 'rgba(31, 37, 46, 1)',
        shadow:
          '0px 1px 4px 1px rgba(13, 17, 23, 0.06), 0px 2px 8px 0px rgba(13, 17, 23, 0.06)',
      },
      6: {
        background: 'rgba(39, 47, 58, 1)',
        shadow:
          '0px 2px 4px 1px rgba(13, 17, 23, 0.1), 0px 2px 8px 0px rgba(13, 17, 23, 0.06)',
      },
      8: {
        background: 'rgba(40, 50, 62, 1)',
        shadow:
          '0px 3px 4px 1px rgba(13, 17, 23, 0.12), 0px 4px 8px 0px rgba(13, 17, 23, 0.08)',
      },
      12: {
        background: 'rgba(56, 67, 82, 1)',
        shadow:
          '0px 2px 8px 1px rgba(13, 17, 23, 0.14), 0px 4px 8px 0px rgba(13, 17, 23, 0.08)',
      },
      24: {
        background: 'rgba(66, 79, 97, 1)',
        shadow:
          '0px 4px 6px 1px rgba(13, 17, 23, 0.18), 0px 4px 10px 0px rgba(13, 17, 23, 0.06)',
      },
    },
    divider: 'rgba(166, 177, 193, 0.12)',
    // TODO: Finally define surfaces behavior
    // there should be consistency between these two colors!
    background: {
      default: '#0D1117',
      paper: '#161D27',
    },
    // @ts-expect-error There must be a way to fix this
    DataGrid: {
      // paper
      bg: '#161D27',
    },
  },
};
